export const environment = {
  production: false,
  // firebase: {
  //   apiKey: "AIzaSyBJTiFLtkgHS49puuuv5A3xH6EKLtLMnWQ",
  //   authDomain: "such-new.firebaseapp.com",
  //   databaseURL: "https://such-new-default-rtdb.firebaseio.com",
  //   projectId: "such-new",
  //   storageBucket: "such-new.appspot.com",
  //   messagingSenderId: "455916163711",
  //   appId: "1:455916163711:web:9446daa3deab18a0cfa54a"
  // }
  // firebase: {
  //   apiKey: "AIzaSyBxmIN4Tsgy17-1mDxMeCbNEcb312GLO8U",
  //   authDomain: "bm-trackmanager.firebaseapp.com",
  //   databaseURL: "https://bm-trackmanager-default-rtdb.firebaseio.com",
  //   projectId: "bm-trackmanager",
  //   storageBucket: "bm-trackmanager.appspot.com",
  //   messagingSenderId: "625514310687",
  //   appId: "1:625514310687:web:c9f4adb294024ad962792a",
  // },
  firebase: {
    apiKey: "AIzaSyCCr0BOONfA3HB-5vBBjCPUtXXRUWdY9x4",
    authDomain: "gt-x-prod-5040e.firebaseapp.com",
    databaseURL: "https://gt-x-prod-5040e-default-rtdb.firebaseio.com",
    projectId: "gt-x-prod-5040e",
    storageBucket: "gt-x-prod-5040e.firebasestorage.app",
    messagingSenderId: "517186252521",
    appId: "1:517186252521:web:62e015af7caf0e96b38a78",
  },
  tenantId: "track-manager-u8d3c",
  server: "https://bm-track-api.globaltote.bet",
};
